import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { InstitutionMemberDisplay } from './InstitutionMemberDisplay';
import { InstitutionMemberGrid } from './InstitutionMemberGrid';
import { MemberInviteDisplay } from './MemberInviteDisplay';
import { Four04 } from 'gossamer-front-end';
import { AddNewMember } from './AddNewMember';
import { MemberSearch } from './MemberSearch';
import { BulkUploadMembers } from './BulkUploadMembers';

export const InstitutionMemberRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/add" element={<AddNewMember />} />
    <Route path="/add-admin" element={<AddNewMember inviteType="admin" />} />
    <Route path="/bulk-upload" element={<BulkUploadMembers />} />
    <Route path="/display/:key" element={<InstitutionMemberDisplay />} />
    <Route path="/display-invite/:key" element={<MemberInviteDisplay />} />
    <Route path="/search" element={<MemberSearch />} />
    <Route path="/update-grid/:key" element={<InstitutionMemberGrid />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
